<template>
  <el-table-column
    align="center"
    label="#"
    width="50"
    fixed
    >
    <template slot-scope="scope">
      <div
        class="allow-click-copy"
        @click="doCopy(scope.row[idField])"
        >
        <el-tooltip class="item"
          effect="dark"
          placement="top-start"
          >
          <div
            slot="content"
            class="tool-tip-content"
            >
            <div
              v-if="scope.row[idField] !== '' && scope.row[idField] !== undefined"
              class="align-center allow-click-copy"
              @click="doCopy(scope.row[idField])"
              >
              {{ scope.row[idField] }}
            </div>
            <div
              v-if="scope.row[unhideIDField] && scope.row[idField] !== scope.row[unhideIDField]"
              >
              <div class="align-center">
                ⮃
              </div>
              <div
                class="align-center allow-click-copy"
                @click="doCopy(scope.row[unhideIDField])"
                >
                {{ scope.row[unhideIDField] }}
              </div>
            </div>
            <div
              v-if="scope.row.created_at"
              class="align-center allow-click-copy"
              @click="doCopy(getTimeText(scope.row.created_at, true))"
              >
              {{ $t('api.createdAt') }}: {{ getTimeText(scope.row.created_at, true) }}
            </div>
            <div
              v-if="scope.row.cancel_at"
              class="align-center allow-click-copy"
              @click="doCopy(getTimeText(scope.row.cancel_at, true))"
              >
              {{ $t('api.orders.fields.cancel_at.label') }}: {{ getTimeText(scope.row.cancel_at, true) }}
            </div>
          </div>
          <span>{{ getIdx(scope.$index) }}</span>
        </el-tooltip>
      </div>
    </template>
  </el-table-column>
</template>

<script>

import { getTimeText } from '@/utils/time'
import { doCopy } from '@/utils/copy'

export default {
  name: 'list-index',
  props: {
    idField: {
      type: String,
      default: 'id'
    },
    unhideIDField: {
      type: String,
      default: 'unhide_id'
    },
    listQuery: {
      type: Object,
      default: null
    }
  },
  methods: {
    getTimeText,
    doCopy,
    getIdx (i) {
      let listIdx = 0
      if (this.listQuery) {
        listIdx = (this.listQuery.page - 1) * this.listQuery.limit
      }
      return 1 + i + listIdx
    }
  }
}
</script>
